import { useEffect } from "react";
import { Link } from "react-router-dom";
import "./ServiceDetail.css";

const RealEstateService = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const services = [
    {
      title: "Smart Home Solutions",
      items: [
        "Home Automation",
        "Smart Security",
        "Energy-Efficient Designs",
        "Modern Interiors",
      ],
    },
    {
      title: "Property Investment",
      items: [
        "Investment Advisory",
        "Market Analysis",
        "Portfolio Management",
        "ROI Optimization",
      ],
    },
    {
      title: "Construction Services",
      items: [
        "Residential Building",
        "Commercial Projects",
        "Renovations",
        "Quality Assurance",
      ],
    },
    {
      title: "Property Management",
      items: [
        "Tenant Management",
        "Maintenance",
        "Rent Collection",
        "Property Marketing",
      ],
    },
  ];

  return (
    <div className="service-detail-page">
      <section className="service-detail-hero">
        <div className="hero-particles"></div>
        <div className="container">
          <Link to="/services" className="back-link">
            ← Back to Services
          </Link>
          <div className="service-detail-hero-content">
            <div className="service-icon-hero">🏡</div>
            <h1>Smart Real Estate</h1>
            <p>
              Build wealth through intelligent property solutions - from smart
              homes to investment advisory and construction services
            </p>
          </div>
        </div>
      </section>

      <section className="service-overview">
        <div className="container">
          <div className="overview-grid">
            <div className="overview-content">
              <h2>Property Solutions That Build Wealth</h2>
              <p>
                We combine smart home technology with strategic real estate
                services to help you make intelligent property decisions.
                Whether you're looking for modern smart homes, investment
                opportunities, or construction services, we provide end-to-end
                solutions.
              </p>
              <p>
                From property acquisition to development and management, our
                expertise ensures your real estate investments work for you.
              </p>
            </div>
            <div className="overview-stats">
              <div className="stat-item">
                <div className="stat-number">100+</div>
                <div className="stat-label">Properties</div>
              </div>
              <div className="stat-item">
                <div className="stat-number">50+</div>
                <div className="stat-label">Smart Homes</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="service-programs">
        <div className="container">
          <h2>Our Services</h2>
          <div className="programs-grid">
            {services.map((service, index) => (
              <div key={index} className="program-item">
                <h3>{service.title}</h3>
                <ul className="program-topics">
                  {service.items.map((item, idx) => (
                    <li key={idx}>{item}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="service-detail-cta">
        <div className="container">
          <h2>Ready to Build Your Wealth?</h2>
          <p>Let's discuss your real estate goals and smart home needs</p>
          <Link to="/contact-us" className="btn btn-light">
            Get Started
          </Link>
        </div>
      </section>
    </div>
  );
};

export default RealEstateService;
